export const bonusesFreeSpinsEnabled: boolean = false;
